import DropDownMenu from './DropDownMenu.view';

export default class DropDownToggle extends DropDownMenu {

    getDropdownEl() {
        return this.$el.find('.header--dropdown-menu');
    }

}
